export const MAX_CHARACTERS = 255;

export const MIN_CHARACTERS = 50;

export const MAX_BROADCAST_RECIPIENTS = 5000;

// Needs to be same as const in application\models\Sms\Edition.php
export const DEFAULT_OPT_OUT_STRING = 'STOP to quit';

export const SMS_EDITION_FILTER_KEYS = [
    'sentSmsEditions',
    'optedOutSmsEditions',
    'bouncedSmsEditions',
    'repliedSmsEditions',
] as const;

export const DRIP_RECIPIENT_STATUS_FILTERS = [
    {
        id: 'inProgressSmsDripSequences',
        name: 'In progress',
    },
    {
        id: 'receivedAllMessagesSmsDripSequences',
        name: 'Received all messages',
    },
    {
        id: 'optedOutSmsDripSequences',
        name: 'Opted out',
    },
    {
        id: 'bouncedSmsDripSequences',
        name: 'Undelivered',
    },
] as const;
